// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "chartkick/chart.js"
import "recurring-select"

import "./controllers"


window.addEventListener("turbo:load", () => {
    document.body.classList.remove("no-js")
    document.body.classList.add("js")
})